<template>
  <div>
     <b-button
      v-permission="'newsletter_workflows.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>
    <Grid
      ref="grid"
      :service="service"
      route_name="newsletter_workflows"
      :route_grid_path="`/grid`"
      order_column="name"
      >
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="name" sort-key="name">{{ $t('newsletter.workflow.name') }}</vs-th>
        <vs-th key="description" sort-key="description">{{ $t('newsletter.workflow.description') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div> {{ tr.id }} </div>
          </vs-td>
          <vs-td width="30%" key="name">
            <div> {{ tr.name }}</div>
          </vs-td>
          <vs-td width="40%" key="description">
            <div v-html-safe="tr.description"></div>
          </vs-td>
          <vs-td width="10%">
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="'newsletter_workflows.edit'"
                icon="EditIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                @click="props.edit(props.data[indextr].id)"
                v-b-tooltip.hover
                :title="$t('action.edit')"
                />
              <feather-icon
                v-permission="'newsletter_workflows.detail'"
                icon="EyeIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-success"
                @click="detail(props.data[indextr])"
                v-b-tooltip.hover
                :title="$t('action.detail')"
                />

                <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                  <feather-icon
                    type="filled"
                    icon="MoreVerticalIcon"
                    class="h-5 w-5 mb-1 mr-1 stroke-current">
                  </feather-icon>
                  <vs-dropdown-menu>
                    <vs-dropdown-item v-permission="'newsletter_workflows.clone'">
                      <div
                        class="flex"
                        style="width: 150px;" @click="confirmClone(props.data[indextr])">
                        <div class="w-2/12">
                          <feather-icon
                              icon="GridIcon"
                              svgClasses="h-5 w-5 mb-1 stroke-current text-primary"/>
                        </div>

                        <div class="w-10/12">
                          <div class="flex bg-gray-200 float-left text-primary">
                            {{ $t('action.clone') }}
                          </div>
                        </div>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item v-permission="'newsletter_workflows.delete'">
                      <div
                        class="flex"
                        style="width: 150px;" @click="confirmDelete(props.data[indextr])">
                        <div class="w-2/12">
                          <feather-icon
                              icon="Trash2Icon"
                              svgClasses="h-5 w-5 mb-1 stroke-current text-danger"/>
                        </div>

                        <div class="w-10/12">
                          <div class="flex bg-gray-200 float-left text-danger">
                            {{ $t('action.delete') }}
                          </div>
                        </div>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>

import { isAdmin } from '@/util/Util'
import { BButton, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import NewsletterWorkflowService from '@/services/api/NewsletterWorkflowService'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BButton,
  },
  data: () => ({
    service: null
  }),
  methods: {
    addNew() {
      this.$router.push('/newsletter_workflows/create')
    },
    reloadGrid(){
      this.$refs.grid.fetchGridData()
    },
    confirmClone(item) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja clonar este workflow: '+item.name+'?',
        accept: () => {
          this.clone(item)
        }
      })
    },
    clone(item) {
      const groupId = _.get(item, 'id')
      if(!groupId){
        this.notifyWarning(this.$vs, 'Não é possível clonar este workflow.', 5000, 'center-top')
        return
      }

      this.$vs.loading()
      this.service.clone(item.id).then(
        response => {
          this.notifySuccess(this.$vs, 'Workflow clonado com sucesso!', 3000, 'center-top')
          this.reloadGrid()
        })
        .catch(error => {
          this.notifyError(this.$vs, 'Erro ao clonar workflow.', 5000, 'center-top')
        })
        .finally(() => this.$vs.loading.close())
    },
    confirmDelete(item) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('action.delete'),
        acceptText: this.$t('action.ok'),
        cancelText: this.$t('action.cancel'),
        text: this.$t('messages.confirm_deletion')+': '+item.name+'?',
        accept: () => {
          this.delete(item)
        }
      })
    },
    delete(item) {
      this.$vs.loading()
      this.service.delete(item.id).then(response => {
        this.notifySuccess(this.$vs, 'Workflow deletado com sucesso!', 3000, 'center-top')
        this.reloadGrid()
      }).finally(() => this.$vs.loading.close())
    },
    detail(item) {
      this.$router.push({name: 'newsletter-workflow-detail', params: {id: item.id}})
    }
  },
  beforeMount() {
    this.service = NewsletterWorkflowService.build(this.$vs)
  }
}
</script>
